import { render } from "./follow_request_card.vue?vue&type=template&id=c31fa72c"
import script from "./follow_request_card.js?vue&type=script&lang=js&external"
export * from "./follow_request_card.js?vue&type=script&lang=js&external"

import "./follow_request_card.vue?vue&type=style&index=0&id=c31fa72c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__